import { useEffect, useState, useRef } from 'react'
import { useTranslation } from "react-i18next";
import { DotsHorizontal, Delete,Edit, Eye, EyeOff } from 'components/misc/Icons'
import { useFireStore } from '../../../firebase/firebase'

import ModalEditPost from 'components/modals/ModalEditPost'
import ModalDeletePost from 'components/modals/ModalDeletePost'

const PostOptions = ({id, hidden}) => {

    const {t, i18n} = useTranslation('common');

    // CLICK OUTSIDE FUNCTIONALITY
    const node = useRef();

    // MODALS
    const [optionsOpen, setOptionsOpen] = useState(false)
    const [modalEditPostOpen, setModalEditPostOpen] = useState(false)
    const [modalDeletePostOpen, setModalDeletePostOpen] = useState(false)

    const [isHidden, setIsHidden] = useState(hidden)

    const hide = async () => {
        await useFireStore.collection("posts")
        .doc(id)
        .update({
            hidden: true,
        });
        setIsHidden(true)
        console.log("Add Like button pressed")
    };

    const unhide = () => {
        useFireStore.collection("posts")
        .doc(id)
        .update({
            hidden: false,
        });
        setIsHidden(false)
    };


    const handleClickOutside = e => {
        if (node.current.contains(e.target)) {
            // inside click
            return;
        }
        setOptionsOpen(false);
    };

    useEffect(() => {
        if (optionsOpen) {
            document.addEventListener("mousedown", handleClickOutside);
        }
        else {
            document.removeEventListener("mousedown", handleClickOutside);
        }
        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, [optionsOpen]);

    return (
        <>
        <div
            ref={node}
            onClick={e => setOptionsOpen(!optionsOpen)}
            className="relative flex items-center justify-center w-8 h-8 cursor-pointer focus:outline-none text-lighttext dark:text-darktext"
        >
            <DotsHorizontal/>
            {optionsOpen && (
                <div className="absolute w-48 py-2 mr-40 overflow-hidden border rounded z-1100 mt-44 bg-itemlight dark:bg-itemdark border-borderlight dark:border-borderdark">
                    <button
                        onClick={() => setModalEditPostOpen(true)}
                        className="flex items-center w-full px-2 py-3 transition-colors duration-200 transform hover:bg-blue-500 hover:text-white dark:hover:bg-borderdark text-textlight dark:text-textdark">
                            <Edit width="6" height="6" stroke="1"/>
                            <span className="ml-2 text-sm font-light">{t('PO_editPost')}</span>
                    </button>
                    {isHidden ? (
                        <button
                            onClick={() => unhide()}
                            className="flex items-center w-full px-2 py-3 transition-colors duration-200 transform hover:bg-blue-500 hover:text-white dark:hover:bg-borderdark text-textlight dark:text-textdark">
                            <Eye width="6" height="6" stroke="1"/>
                            <span className="ml-2 text-sm font-light">{t('PO_unhidePost')}</span>
                        </button>
                    ) : (
                        <button
                            onClick={() => hide()}
                            className="flex items-center w-full px-2 py-3 transition-colors duration-200 transform hover:bg-blue-500 hover:text-white dark:hover:bg-borderdark text-textlight dark:text-textdark">
                            <EyeOff width="6" height="6" stroke="1"/>
                            <span className="ml-2 text-sm font-light">{t('PO_hidePost')}</span>
                        </button>
                    )}
                    <button
                        onClick={() => setModalDeletePostOpen(true)}
                        className="flex items-center w-full px-2 py-3 transition-colors duration-200 transform hover:bg-blue-500 hover:text-white dark:hover:bg-borderdark text-lighttext dark:text-darktext">
                            <Delete width="6" height="6" stroke="1"/>
                            <span className="ml-2 text-sm font-light">{t('PO_deletePost')}</span>
                    </button>
                </div>
            )}
        </div>
        <ModalEditPost open={modalEditPostOpen} onClose={() => setModalEditPostOpen(false)} id={id}/>
        <ModalDeletePost
            open={modalDeletePostOpen}
            onClose={() => setModalDeletePostOpen(false)}
            id={id}
        />
        </>
    )
}

export default PostOptions
